var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watch-footer"},[_c('main',[_c('section',[_c('nav',{attrs:{"title":_vm.name}},[_vm._v(" "+_vm._s(_vm.name)+" ")])]),_c('ul',{staticClass:"watch-folder-info"},[(_vm.onlineUsers)?_c('li',{staticClass:"person-online"},[_c('Person'),_c('span',[_vm._v(_vm._s(_vm.onlineUsers))])],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }